{
  "anchoring": {
    "nav": "Fortbildning",
    "title": "Fortbildning",
    "description": "Skapa quiz för publicerade dokument och följ upp vilka som har genomfört dem.",
    "tabs": {
      "unanchored": "Ej förankrade dokument",
      "anchored": "Förankrade dokument",
      "mine": "Mina quizzar"
    },
    "status": {
      "take": "Gå till quiz",
      "completed": "Genomförd"
    },
    "manage": {
      "heading": "Quiz",
      "empty": "Inget quiz har skapats för det här dokumentet ännu.",
      "create": "Skapa quiz",
      "createDescription": "Generera ett quiz från dokumentet. Lägg till en valfri prompt för att fokusera frågorna.",
      "creating": "Genererar quiz…",
      "error": "Det gick inte att skapa quizet. Försök igen.",
      "edit": "Redigera quiz",
      "invited": "Inbjudna",
      "completed": "Genomfört",
      "taker": "Deltagare",
      "status": "Status",
      "notCompleted": "Ej genomfört",
      "noTakers": "Ingen är inbjuden ännu."
    },
    "documentTab": {
      "availableTitle": "Quiz tillgängligt",
      "availableDescription": "Gör quizet för det här dokumentet.",
      "take": "Gå till quiz",
      "completedTitle": "Quiz genomfört",
      "completedDescription": "Du svarade rätt på alla frågor."
    },
    "columns": {
      "title": "Dokument",
      "createdBy": "Skapad av",
      "createdAt": "Skapad",
      "owner": "Ägare",
      "publisher": "Publicerare",
      "publishedAt": "Publicerad",
      "adoptedAt": "Antagen",
      "tags": "Taggar",
      "takers": "Genomförda / inbjudna"
    },
    "actions": {
      "inviteTakers": "Bjud in deltagare",
      "createQuizzes": "Skapa quiz"
    },
    "empty": {
      "unanchored": "Inga ej förankrade dokument.",
      "anchored": "Inga förankrade dokument.",
      "mine": "Du har inte blivit inbjuden till några quizzar."
    },
    "invite": {
      "title": "Bjud in deltagare",
      "description_one": "Bjud in användare till det valda quizet.",
      "description_other": "Bjud in användare till {{count}} valda quizzar.",
      "success": "Deltagare inbjudna"
    },
    "create": {
      "title": "Skapa quiz",
      "description": "Ett quiz genereras för varje valt dokument. Lägg till en valfri prompt för att styra frågorna, eller ta bort dokument du inte vill ha med.",
      "promptPlaceholder": "Valfritt: vad ska frågorna fokusera på?",
      "create": "Skapa quiz",
      "error_one": "Ett quiz kunde inte skapas. Du kan försöka igen.",
      "error_other": "{{count}} quiz kunde inte skapas. Du kan försöka igen.",
      "removeDocument": "Ta bort dokument"
    },
    "quiz": {
      "back": "Tillbaka till förankring",
      "takeQuiz": "Gör quiz",
      "viewDocument": "Visa dokument",
      "notFound": "Quizet kunde inte hittas.",
      "take": {
        "progress": "Fråga {{current}} av {{total}}",
        "incorrect": "Det är inte rätt. Försök med ett annat svar.",
        "reasonHeading": "Varför det här är rätt",
        "next": "Nästa fråga",
        "finish": "Slutför",
        "error": "Kunde inte registrera att du genomfört quizet. Försök igen.",
        "alreadyCompletedTitle": "Du har genomfört det här quizet",
        "alreadyCompletedDescription": "Du svarade rätt på alla frågor, så det finns inget mer att göra.",
        "backToList": "Tillbaka till dina quizzar"
      },
      "edit": {
        "questionLabel": "Fråga {{number}}",
        "questionPlaceholder": "Frågetext",
        "optionPlaceholder": "Svarsalternativ",
        "reasonLabel": "Motivering (visas efter ett rätt svar)",
        "reasonPlaceholder": "Lägg till en motivering i klartext, eller lämna tomt.",
        "removeReason": "Ta bort motivering",
        "addOption": "Lägg till alternativ",
        "addQuestion": "Lägg till fråga",
        "save": "Spara quiz",
        "saved": "Quiz sparat",
        "error": "Kunde inte spara quizet. Försök igen.",
        "optionsLabel": "Svarsalternativ (markera det rätta)",
        "correctOption": "Markera alternativ {{number}} som rätt",
        "removeOption": "Ta bort alternativ",
        "removeQuestion": "Ta bort fråga"
      }
    }
  }
}
